export function useDownloadController() {
    async function downloadLargeFile(apiUrl) {
        const anchor = document.createElement('a');
        anchor.href = apiUrl;
        anchor.click();
    }
    return {
        downloadLargeFile,
    };
}
